import { render } from "./StarsForm.vue?vue&type=template&id=470067ca&scoped=true"
import script from "./StarsForm.vue?vue&type=script&lang=js"
export * from "./StarsForm.vue?vue&type=script&lang=js"

import "./StarsForm.vue?vue&type=style&index=0&id=470067ca&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470067ca"]])

export default __exports__